import { render } from "./detail_surcharge.vue?vue&type=template&id=48f7b09f&scoped=true"
import script from "./detail_surcharge.vue?vue&type=script&lang=js"
export * from "./detail_surcharge.vue?vue&type=script&lang=js"

import "./detail_surcharge.vue?vue&type=style&index=0&id=48f7b09f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f7b09f"]])

export default __exports__